import { HttpHandler } from 'msw'

import { createRefund } from './createRefund'

export const refunds: HttpHandler[] = [createRefund]
